import type { Reducer } from '@reduxjs/toolkit';

export type DomoState = {
  activeDashboard: string;
};

const initialState: DomoState = {
  activeDashboard: '',
};

export type SetActiveDashboard = { type: 'Domo/SET_ACTIVE_DASHBOARD'; dashboard: string };

type Action = SetActiveDashboard;

export const setActiveDashboard = (dashboard: string) => ({
  type: 'Domo/SET_ACTIVE_DASHBOARD',
  dashboard,
});

const reducer = (state: DomoState = initialState, action: Action): DomoState => {
  switch (action.type) {
    case 'Domo/SET_ACTIVE_DASHBOARD':
      return {
        ...state,

        activeDashboard: action.dashboard,
      };

    default:
      return state;
  }
};

export default reducer as Reducer<DomoState>;
